import React from 'react';
import { Link } from 'gatsby';
import CountryField from '../CountryField';
import NumberWithSuffix from '../NumberWithSuffix.js';
const CountryItem = ({ countryCode, position }) => {
	return (
		<li className="rankings__list-item">
			<Link to={`/countries/${countryCode.toLowerCase()}`}>
				<div className="rankings__position p-0">
					<NumberWithSuffix number={position} />
				</div>
				<div className="rankings__country">
					<CountryField code={countryCode} />
				</div>
			</Link>
		</li>
	);
};
const CountryList = ({ countries = [] }) => {
	return <ul className="rankings__list">{countries.map(CountryItem)}</ul>;
};
export const RankingItemComponent = (props, idx) => {
	const { IconComponent, title, description, countries, link } = props;
	return (
		<div
			className="rankings__block"
			data-sal="slide-up"
			data-sal-delay={idx * 150}
			data-sal-duration="350"
			data-sal-easing="ease"
		>
			<IconComponent />
			<h3 className="section-title">{title}</h3>
			<p className="section-text">{description}</p>
			<CountryList countries={countries} />
			<Link to={link} className="btn btn__secondary">
				View full ranking
			</Link>
		</div>
	);
};
